import React from 'react'
import styles from './AlertBox.module.scss'

type Variant = 'success' | 'error' | 'warning' | 'info'

interface AlertBoxProps {
  children: React.ReactNode
  variant?: Variant
  className?: never
}

const variantMap: Record<Variant, string> = {
  success: styles.success, error: styles.error, warning: styles.warning, info: styles.info,
}

export const AlertBox: React.FC<AlertBoxProps> = ({ children, variant = 'info' }) => (
  <div className={[styles.alert, variantMap[variant]].join(' ')}>{children}</div>
)
